import classNames from 'classnames';
import { FunctionComponent } from 'react';

import './Waiting.scss';

interface IProps {
  className?: string | object;
  size?: 'small' | 'medium';
}

export const Waiting: FunctionComponent<IProps> = (props) => {
  const { className, size } = props;

  const classes = classNames(
    {
      waiting: true,
      [`${size}`]: size,
    },
    className
  );

  return (
    <div className={classes}>
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
    </div>
  );
};

export default Waiting;
